import React, { ReactNode } from "react";
import { Col } from "antd";

interface Props {
  xs?: number;
  sm?: number;
  md?: number;
  xl?: number;
  lg?: number;
  children: ReactNode;
}

export const ColComponent = ({ xs, sm, md, xl, lg, children }: Props) => {
  return (
    <Col
      xs={xs || 24}
      sm={sm || 24}
      md={md || 24}
      lg={lg || 24}
      xl={xl || 24}
      className="mb-24"
    >
      {children}
    </Col>
  );
};
